<template>
  <div class="body">
    <div class="bg-white p20">
      <!-- <h2 class="body-title">添加培训计划</h2> -->
      <div class="f--c mb20">
        <h2>
          基本信息
          <span class="required">*</span>
        </h2>
        <div class="hr"></div>
      </div>
      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-row>
          <el-col :span="24" class="pr20">
            <el-form-item label="课程名称" prop="trainingName" class="item">
              <el-input :disabled="$route.query.type == 'check'" v-model="form.trainingName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="pr20">
            <el-form-item label="培训类型" prop="trainingCategoryName">
              <el-input
                @focus="showSelectTreeCategoryVisible"
                @clear="trainingCategoryClear"
                ref="trainingCategoryInput" clearable
                        :disabled="$route.query.type == 'check'" v-model="form.trainingCategoryName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="课程目录" prop="directoryId">
              <selectTree :props="{
                                    value: 'id', // ID字段名
                                    label: 'directoryName', // 显示名称
                                    children: 'directoryList', // 子级字段名
                                }" :options="catalogList" :value="form.directoryId"
                          :disabled="$route.query.type == 'check'" @getValue="selectTreeChange" ></selectTree>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb20">
          <el-col :span="4" class="pr20 swi">
            <el-form-item label="是否通用" prop="isGood" class="item">
              <el-switch style="display: block" :disabled="$route.query.type == 'check'" v-model="form.isGood"
                         active-color="#13ce66" inactive-color="#ff4949" active-text="是" inactive-text="否"
                         :active-value="1"
                         :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="pr20 swi">
            <el-form-item label="是否免费" prop="isCommon" class="item">
              <el-switch style="display: block" :disabled="$route.query.type == 'check'" v-model="form.isCommon"
                         active-color="#13ce66" inactive-color="#ff4949" active-text="是" inactive-text="否"
                         :active-value="1"
                         :inactive-value="0" @change="on('switch-is-common')"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="pr20 swi">
            <el-form-item label="是否热门" prop="isHot" class="item">
              <el-switch style="display: block" :disabled="$route.query.type == 'check'" v-model="form.isHot"
                         active-color="#13ce66" inactive-color="#ff4949" active-text="是" inactive-text="否"
                         :active-value="1"
                         :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="pr20 swi">
            <el-form-item label="是否精选" prop="isSelected" class="item">
              <el-switch style="display: block" :disabled="$route.query.type == 'check'" v-model="form.isSelected"
                         active-color="#13ce66" inactive-color="#ff4949" active-text="是" inactive-text="否"
                         :active-value="1"
                         :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="pr20 swi" v-if="isOperating">
            <el-form-item label="上架状态" prop="shelf" class="item">
              <el-switch style="display: block" :disabled="$route.query.type == 'check'" v-model="form.shelf"
                         active-color="#13ce66" inactive-color="#ff4949" active-text="是" inactive-text="否"
                         :active-value="true"
                         :inactive-value="false"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="">
          <el-form-item>
            <div style="color: red">
              免费课程如果后期需要付费，请下架或删除该课程，重新新增课程
            </div>
          </el-form-item>
        </el-row>

        <el-row class="mb20">
          <el-col :span="6" class="pr20">
            <el-form-item label="累计课时" prop="totalHour" class="item">
              <el-input-number type="number" v-model="form.totalHour" :disabled="$route.query.type == 'check'" :min="0"
                               :max="10000" :step="1"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="累计课件总数" prop="totalNumber" class="item" label-width="100px">
              <el-input-number type="number" v-model="form.totalNumber" :disabled="true" :min="0" :max="10000"
                               :step="1"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="总价格" prop="totalPrice" class="item">
              <el-input-number type="number" v-model="form.totalPrice"
                               :disabled="$route.query.type == 'check' || form.isCommon === 1" :min="0" :max="100000"
                               :step="1"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="排序" prop="sort" class="item">
              <el-input-number type="number" v-model="form.sort" :disabled="$route.query.type == 'check'" :min="0"
                               :max="100000" :step="1"></el-input-number>

              <el-tooltip class="item" effect="dark" content="排序：数值越大,排序在前" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>

            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="图片" prop="pictureUrl">
              <template v-if="$route.query.type == 'check'">
                <img width="150px" :src="form.pictureUrl" alt=""/>
              </template>
              <template v-else>
                <el-upload-e :dir="ossConstant.dir.mallCoursewareImage"
                             :limit="upload.imgLimit"
                             :file-list="upload.productImgs"
                             :multiple="upload.isMultiple"
                             @onRemove="handleRemove"
                             @onSuccess="handleAvatarSuccess"
                             :accept="'.png,.jpg'">
                </el-upload-e>
              </template>
              <el-dialog :visible.sync="upload.dialogVisible">
                <img width="100%" :src="`upload`.dialogImageUrl" alt=""/>
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20" class="pr20">
            <el-form-item label="课程详情" prop="trainingContent">
              <!--                                          <quillEditor-->
              <!--                                            v-if="$route.query.type != 'check'"-->
              <!--                                            v-model="form.trainingContent"-->
              <!--                                            ref="myQuillEditor"-->
              <!--                                            :options="editorOption"-->
              <!--                                          ></quillEditor>-->
              <!--                                          <div v-else v-html="form.trainingContent"></div>-->
              <el-input :disabled="$route.query.type == 'check'" type="textarea" v-model="form.trainingContent"
                        placeholder></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20" class="pr20">
            <el-form-item label="课程介绍" prop="trainingContent">
              <quillEditor
                v-if="$route.query.type != 'check'"
                v-model="form.trainingIntroduction"
                ref="myQuillEditor"
                :options="editorOption"
              ></quillEditor>
              <div v-else v-html="form.trainingIntroduction"></div>
            </el-form-item>
          </el-col>
        </el-row>


        <!--培训资料  -->
        <div class="f--c mb20">
          <h2>
            关联课件
            <span class="required">*</span>
          </h2>
          <div class="hr"></div>
        </div>
        <el-button v-if="$route.query.type == 'edit'" type="primary" icon="el-icon-plus" @click="showAddData">关联课件
        </el-button>
        <associateResource ref="associateResource" style="margin-top: 15px"></associateResource>

        <!--关联考试  -->
        <div class="f--c mb20">
          <h2>关联考试</h2>
          <div class="hr"></div>
        </div>
        <el-button v-if="$route.query.type == 'edit'" type="primary" icon="el-icon-plus" @click="showCorrelationExam">
          关联考试
        </el-button>
        <el-table :data="dataList3" style="width: 100%;margin:20px 0px;">
          <el-table-column prop="questionsPaperName" label="试卷名称"></el-table-column>
          <el-table-column label="试卷类型">
            <template slot-scope="scope">{{ scope.row.selectionMode == 0 ? "随机试卷" : "固定试卷" }}</template>
          </el-table-column>
          <el-table-column prop="questionNumber" label="包含题目数量"></el-table-column>
          <el-table-column label="操作" v-if="$route.query.type == 'edit'">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="delPaper(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="searchBut" style="text-align: center">
          <el-button @click="$router.back(-1)">返回</el-button>
          <el-button v-if="$route.query.type == 'edit'" type="primary" @click="save" :loading="saveLoading">保存
          </el-button>
        </div>
      </el-form>
    </div>

    <!--关联课件选择-->
    <resourcesDataSelector ref="resourcesDataSelector" @confirm="confirm"></resourcesDataSelector>
    <!--关联考试选择-->
    <examSelector ref="examSelector" @confirm="confirm2"></examSelector>
    <!--培训分类选择器-->
    <selectTrainingCategory ref="selectTrainingCategory"
                            @submit="selectTrainingCategorySubmitHandle"></selectTrainingCategory>
  </div>
</template>

<script>
import api from "@/api/mall/training.js";
import api_user from "@/api/api_user.js";
import exam from "@/api/mall/exam.js";
import selectTree from "@/components/common/selectTree";
import selectTrainingCategory from "@/components/training/selectTrainingCategory";

import {
  quillEditor
} from "vue-quill-editor";
import resourcesDataSelector from "@/pages/mall/component/resourcesDataSelector.vue";
import examSelector from "@/pages/mall/component/examSelector.vue";

import elUploadE from "@/components/common/oss/ossUpload";
import $ossConstant from "@/components/common/oss/ossConstant";

import associateResource from "@/components/training/associateResource";

/*富文本编辑图片上传配置*/
const uploadConfig = {
  action: process.env.API_ROOT + "/clouddo-tranning/training/record/upload", // 必填参数 图片上传地址
  methods: "POST", // 必填参数 图片上传方式
  // token: window.localStorage.getItem("access-token"), // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
  name: "file", // 必填参数 文件的参数名
  size: 500, // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
  accept: "image/png, image/gif, image/jpeg, image/bmp, image/x-icon", // 可选 可上传的图片格式
};
const handlers = {
  image: function image() {
    var self = this;

    var fileInput = this.container.querySelector("input.ql-image[type=file]");
    if (fileInput === null) {
      fileInput = document.createElement("input");
      fileInput.setAttribute("type", "file");
      // 设置图片参数名
      if (uploadConfig.name) {
        fileInput.setAttribute("name", uploadConfig.name);
      }
      // 可设置上传图片的格式
      fileInput.setAttribute("accept", uploadConfig.accept);
      fileInput.classList.add("ql-image");
      // 监听选择文件
      fileInput.addEventListener("change", function () {
        // 创建formData
        var formData = new FormData();
        formData.append(uploadConfig.name, fileInput.files[0]);
        formData.append("object", "product");
        // 如果需要token且存在token
        if (uploadConfig.token) {
          formData.append("token", uploadConfig.token);
        }
        // 图片上传
        var xhr = new XMLHttpRequest();
        xhr.open(uploadConfig.methods, uploadConfig.action, true);
        xhr.setRequestHeader("Authorization", window.localStorage.getItem("access-token"));
        // 上传数据成功，会触发
        xhr.onload = function (e) {
          if (xhr.status === 200) {
            var res = JSON.parse(xhr.responseText);
            let length = self.quill.getSelection(true).index;
            //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
            console.log(res.data);
            self.quill.insertEmbed(length, "image", "http://" + res.data);
            self.quill.setSelection(length + 1);
          }
          fileInput.value = "";
        };
        // 开始上传数据
        xhr.upload.onloadstart = function (e) {
          fileInput.value = "";
        };
        // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
        xhr.upload.onerror = function (e) {
        };
        // 上传数据完成（成功或者失败）时会触发
        xhr.upload.onloadend = function (e) {
          // console.log('上传结束')
        };
        xhr.send(formData);
      });
      this.container.appendChild(fileInput);
    }
    fileInput.click();
  },
};
// toolbar工具栏的工具选项（默认展示全部）
const toolOptions = [["bold", "italic", "underline", "strike"], ["blockquote", "code-block"], [{header: 1}, {header: 2}], [{list: "ordered"}, {list: "bullet"}], [{script: "sub"}, {script: "super"}], [{indent: "-1"}, {indent: "+1"}], [{direction: "rtl"}], [{size: ["small", false, "large", "huge"]}], [{header: [1, 2, 3, 4, 5, 6, false]}], [{color: []}, {background: []}], [{font: []}], [{align: []}], ["clean"], ["image"]];

export default {
  components: {
    quillEditor,
    selectTree,
    selectTrainingCategory,
    resourcesDataSelector,
    examSelector,
    elUploadE,
    associateResource
  },
  data() {
    return {
      ossConstant: $ossConstant,
      id: undefined, //
      type: undefined, //
      selectTreeCategoryVisible: false,
      form: {
        trainingName: undefined,
        implementationDateTime: undefined,
        departmentId: undefined,
        department: undefined,
        principalId: undefined,
        directoryId: undefined,
        directoryName: undefined,
        // principalName: undefined,
        location: undefined,
        trainingContent: undefined,
        shelf: false,
        pictureUrl: undefined,
        teachersId: undefined,
        // training category
        trainingLevelIds: undefined,
        trainingLevelName: undefined,
        trainingIndustryIds: undefined,
        trainingIndustryName: undefined,
        trainingPostIds: undefined,
        trainingPostName: undefined,
        trainingTypeIds: undefined,
        trainingTypeName: undefined,
        trainingCategoryName: undefined,
        isGood: 0,
        isCommon: 0,
        isSelected: 0,
        isHot: 0,
        totalPrice: 0,
        totalNumber: 0,
        totalHour: 0,
        sort: 0,
        trainingIntroduction: undefined,
      },
      rules: {
        trainingName: [{required: true, message: "请输入课程名称", trigger: "blur"}],
        principalId: [{required: true, message: "请输入"}],
        departmentId: [{required: true, message: "请输入"}],
        directoryId: [{required: true, message: "请选择课程目录"}],
        trainingContent: [{required: true, message: "请输入课程详情"}],
        pictureUrl: [{required: true, message: "请上传图片"}]
        // trainingCategoryName: [{ required: true, message: "请选择培训类型", trigger: "blur" }],
      },
      saveLoading: false,
      correlationExamForm: {
        openBook: undefined,
        selectionMode: undefined,
        questionsPaperName: undefined,
      },
      principalList: [], // 负责人列表
      departmentList: [], // 部门列表
      categoryList: [],
      dataForm: {
        dataName: undefined,
        professionalCategory: undefined, // 专业类别
        departmentId: undefined, // 部门id
      },
      dataList: [], // 课程资源列表
      selectDataList: [], // 选择的课程资源列表
      selectPaperList: [], // 选择的试卷列表
      dataList2: [], //培训资料列表
      dataList3: [], //试卷列表

      isShowData: false,
      isShowCorrelationExam: false,
      paperList: [], // 试卷列表
      annexList: [], //附件列表

      uploadUrl: "",
      headers: {
        Authorization: "",
      },

      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      page2: 1,
      pageSize2: 20,
      total2: 0,

      deptTree: [],
      dept: {},

      upload: {
        dialogImageUrl: "",
        dialogVisible: false,
        productImgs: [],
        isMultiple: true,
        imgLimit: 1,
        action: process.env.API_ROOT + "/api-base/sysAtt/save",
      },
      editorOption: {
        //  富文本编辑器配置
        placeholder: "",
        theme: "snow", // 主题
        modules: {
          // 新增下面
          imageDrop: true, // 拖动加载图片组件。
          imageResize: {
            //调整大小组件。
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
            modules: ["Resize", "DisplaySize", "Toolbar"],
          },
          toolbar: {
            container: toolOptions, // 工具栏选项
            // handlers: handlers // 事件重写
          },
        },
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false,
        },
        imageDrop: true,
        imageResize: {
          displayStyles: {
            backgroundColor: "black",
            border: "none",
            color: "white",
          },
          modules: ["Resize", "DisplaySize", "Toolbar"],
        },
      },
      catalogList: [], // 试题目录
      teachersOptions: [], // 教师options
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    if (this.id) this.getProgramDetail();
    this.departmentList = JSON.parse(localStorage.getItem("departmentList"));
    this.categoryList = JSON.parse(localStorage.getItem("categoryList"));
    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));
    this.uploadUrl = process.env.API_ROOT + "/clouddo-tranning/training/resources/data/upload";
    this.headers.Authorization = window.localStorage.getItem("access-token");
    this.loadTeachersOptions();
    this.getCatalogList();
  },
  methods: {
    on(type, item = {}) {
      if (type === "switch-is-common") {
        if (this.form.isCommon === 1) {
          this.form.totalPrice = 0;
        } else {
          this.calculateResources(this.dataList2);
        }
      }
    },
    showSelectTreeCategoryVisible() {
      this.$refs.trainingCategoryInput.blur();
      this.$refs.selectTrainingCategory.showDialog();
    },
    trainingCategoryClear(){
      this.form.trainingLevelName = undefined;
      this.form.trainingLevelIds = undefined;
      this.form.trainingIndustryName = undefined;
      this.form.trainingIndustryIds = undefined;
    },
    deptChange(v) {
      this.dept = v;
      this.form.departmentId = v.id;
    },
    pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    getProgramDetail() {
      api.getProgramDetail({
        programId: this.id
      }).then((res) => {
        this.form.trainingName = res.data.trainingName;
        this.form.implementationDateTime = res.data.implementationTime;
        this.form.departmentId = parseInt(res.data.departmentId);
        this.form.department = res.data.department;
        this.form.principalId = parseInt(res.data.principalId);
        this.form.principalName = res.data.principalName;
        this.form.location = res.data.location;
        this.form.trainingContent = res.data.trainingContent;
        this.form.pictureUrl = res.data.pictureUrl;
        this.annexList = res.data.annexList;
        this.form.shelf = res.data.shelf;
        this.form.directoryId = res.data.directoryId;
        this.form.teachersId = res.data.teachersId;
        this.form.trainingIntroduction = res.data.trainingIntroduction;
        this.form.sort = res.data.sort;
        this.form.trainingLevelName = res.data.trainingLevelName;
        this.form.trainingLevelIds = res.data.trainingLevelIds;
        this.form.trainingIndustryName = res.data.trainingIndustryName;
        this.form.trainingIndustryIds = res.data.trainingIndustryIds;
        this.form.trainingPostName = res.data.trainingPostName;
        this.form.trainingTypeName = res.data.trainingTypeName;
        this.form.trainingCategoryName = res.data.trainingCategoryName;
        this.form.isGood = res.data.isGood;
        this.form.isCommon = res.data.isCommon;
        this.form.isSelected = res.data.isSelected;
        this.form.isHot = res.data.isHot;
        this.form.totalPrice = res.data.totalPrice;
        this.form.totalNumber = res.data.totalNumber;
        this.form.totalHour = res.data.totalHour;

        res.data.trainingProgramJoinDataVos.forEach((v) => {
          if (this.categoryList && this.categoryList.length > 0) {
            this.categoryList.forEach((v2) => {
              if (v.professionalCategory == v2.code) {
                v.categoryName = v2.text;
              }
            });
          }
        });

        this.dataList2 = res.data.trainingProgramJoinDataVos;

        if (res.data.trainingProgramJoinPaperVos) {
          res.data.trainingProgramJoinPaperVos.forEach((v) => {
            v.questionNumber = v.questionsNumber;
          });
        }
        this.$refs.associateResource.setDataList(this.dataList2,"1");
        this.dataList3 = res.data.trainingProgramJoinPaperVos;

        // 图片回显
        this.upload.productImgs = [{name: '课程图片', url: res.data.pictureUrl}];
      });
    },
    save() {
      this.$refs.form.validate((validate) => {
        if (validate == false) return;
        if (this.form.isSelected === 1 && this.form.totalPrice === 0) {
          this.$message.error("课程价格不能为0！");
          return;
        }
        if (this.form.isGod === 1 && this.form.totalPrice === 0) {
          this.$message.error("课程价格不能为0！");
          return;
        }
        if (this.form.isHot === 1 && this.form.totalPrice === 0) {
          this.$message.error("课程价格不能为0！");
          return;
        }

        let p = {
          ...this.form,
          trainingProgramJoinDataSaveDtos: [],
          trainingProgramJoinPaperSaveDtos: [],
          annexList: this.annexList,
          // enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
          //   .enterpriseId
        };

        delete p.trainingCategoryName;


        //清空附带数据
        p.pictureUrl = undefined;

        this.dataList2.forEach((v) => {
          p.trainingProgramJoinDataSaveDtos.push({
            trainingResourcesDataId: v.id ? v.id : v.trainingResourcesDataId,
            dataName: v.dataName,
            professionalCategory: v.professionalCategory,
            department: v.department,
            departmentId: v.departmentId,
          });
        });

        if (this.dataList3 && this.dataList3.length > 0) {
          this.dataList3.forEach((v) => {
            p.trainingProgramJoinPaperSaveDtos.push({
              questionsPaperId: v.id || v.questionsPaperId,
              questionsPaperName: v.questionsPaperName,
              questionsPaperType: v.selectionMode !== undefined ? v.selectionMode : v.questionsPaperType,
              questionsNumber: v.questionsNumber !== undefined ? v.questionsNumber : v.questionNumber,
            });
          });
        }
        this.departmentList.forEach((v) => {
          if (p.departmentId == v.id) p.department = v.deptName;
        });

        if (this.id) p.id = this.id;
        if (p.trainingProgramJoinDataSaveDtos.length == 0) return this.$message.error("请添加培训课件");
        this.saveLoading = true;
        api.addProgram(p).then((res) => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.$router.go(-1);
          } else {
            this.saveLoading = false;
            this.$message.error(res.message);
          }
        });
      });
    },
    //上传文件成功回调
    uploadSuccess(e) {
      if (e.code == 0) {
        this.annexList.push(e.data);
      } else {
        this.$message.error(e.message);
      }
    },
    delData(index) {
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.dataList2.splice(index, 1);
      });
    },
    delPaper(index) {
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.dataList3.splice(index, 1);
      });
    },
    // 添加培训资料,确定
    confirm(selectDataList) {
      this.dataList2 = [];
      selectDataList.forEach((v) => {
        this.dataList2.push(v);
      });
      this.form.totalHour = 0;
      this.dataList2.forEach((obj) => {
        this.form.totalHour += obj.totalSuggestedDuration;
      });
      console.log(this.dataList2)
      this.$refs.associateResource.setDataList(this.dataList2);
    },
    // 关联考试,确定
    confirm2(selectDataList) {
      this.dataList3 = [];
      selectDataList.forEach((v) => {
        this.dataList3.push(v);
      });
    },
    showAddData() {
      this.$refs.resourcesDataSelector.show();
      this.$refs.resourcesDataSelector.setSelection(this.dataList2);
    },
    showCorrelationExam() {
      this.$refs.examSelector.show();
      this.$refs.examSelector.setSelection(this.dataList3);
    },
    //重置表单
    resetForm(formName) {
      console.log(formName);
      this.$refs[formName].resetFields();
    },
    //  图片上传回调代码
    handleRemove(file, fileList) {
      this.upload.productImgs = fileList;
    },
    handlePictureCardPreview(file) {
      //预览图片时调用
      console.log(file);
      this.upload.dialogImageUrl = file.url;
      this.upload.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      //文件上传之前调用做一些拦截限制
      console.log(file);
      const isJPG = true;
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess(res, data) {
      this.form.picture = data.name;
      this.form.pictureUrl = data.url;
    },
    handleExceed(files, fileList) {
      //图片上传超过数量限制
      this.$message.error("只能上传" + this.upload.imgLimit + "张图片");
      console.log(file, fileList);
    },
    imgUploadError(err, file, fileList) {
      //图片上传失败调用
      console.log(err);
      this.$message.error("上传图片失败!");
    },
    getCatalogList() {
      exam.getCatalogList({
        type: 4,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
        //   .enterpriseId
      }).then((res) => {
        this.catalogList = res.data;
      });
    },
    loadTeachersOptions() {
      exam.getTeachersOptions({}).then((res) => {
        this.teachersOptions = res.data;
      });
    },
    selectTreeChange(v) {
      this.form.directoryId = v.id;
      this.form.directoryName = v.text;
    },
    showSelectTreeCategory() {
      this.selectTreeCategoryVisible = true;
    },
    selectTrainingCategorySubmitHandle(data) {

      this.form.trainingLevelIds = data.trainingLevelId? [data.trainingLevelId] : undefined;
      this.form.trainingLevelName = data.trainingLevelName;

      this.form.trainingIndustryIds = data.trainingIndustryId? [data.trainingIndustryId] : undefined;
      this.form.trainingIndustryName = data.trainingIndustryName;

      // this.form.trainingPostIds = [data.trainingPostId];
      // this.form.trainingPostName = data.trainingPostName;
      //
      // this.form.trainingTypeIds = [data.trainingTypeId];
      // this.form.trainingTypeName = data.trainingTypeName;

      this.form.trainingCategoryName = data.trainingCategoryName;

      this.$refs.form.validateField("trainingCategoryName");
    },
    /**
     * 判断是否是运营人员
     */
    isOperating() {
      let userInfo = JSON.parse(localStorage.getItem("userinfo"));
      return userInfo.isOperating;
    },
    calculateResources(val) {
      let dataPrice = 0;
      let totalSuggestedDuration = 0;

      val.forEach(v => {
        dataPrice = (dataPrice * 100 + v.dataPrice * 100) / 100
        totalSuggestedDuration = (totalSuggestedDuration * 100 + v.totalSuggestedDuration * 100) / 100
      })

      if (dataPrice !== 0 && this.form.isCommon !== 1) {
        this.form.totalPrice = dataPrice;
      }
      if (val.length < 1 && this.form.isCommon !== 1) {
        this.form.totalPrice = 0;
      }
      this.form.totalNumber = val.length;
      this.form.totalHour = totalSuggestedDuration;
    }
  },
  watch: {
    "form.departmentId": function (deptId) {
      api_user.getByDept({
        deptId
      }).then((res) => {
        this.principalList = res.data;
      });
    },
    dataList2: {
      handler(val) {
        this.calculateResources(val);
      },
      deep: true
    }
  },
};
</script>

<style lang="scss">
.swi {
  .el-form-item__label {
    white-space: nowrap;
    line-height: 23px;
  }
}

.el-form-item__label {
  white-space: nowrap;
}

.required {
  color: red;
}

.hr {
  height: 2px;
  background: #e4e4e4;
  flex: 1;
  margin-left: 20px;
}

.f--c {
  margin-top: 25px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/course/addCourse.vue